// From https://github.com/foxhound87/mobx-react-form-demo/blob/master/src/components/forms/FormRegisterSimple.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Redirect, Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

import Input from './inputs/SimpleInput';
import Gravatar from '../users/Gravatar.jsx';

const delivermediaLogo = require('../navigation/images/delivermedia.svg');

const LoginLogo = ({ email, size }) => {
    // We expect valid e-mail from the form to return Gravatar
    if (email) {
        return (
            <div style={{ height: size }}>
                <Gravatar email={email} size={size} https className="rounded-circle mx-auto d-block" />
            </div>
        );
    }
    return (
        <div style={{ height: size, paddingTop: 40 }}>
            <img alt="deliver.media Logo" src={delivermediaLogo} />
        </div>
    );
};
LoginLogo.propTypes = {
    email: PropTypes.string,
    size: PropTypes.number,
};
LoginLogo.defaultProps = {
    email: '',
    size: 150,
};

@inject('auth') @observer
class FormSignin extends Component {
    redirectToAzureAd() {
        window.location = '/auth/azuread/';
    }

    render() {
        const { auth, form } = this.props;

        const emailField = form.select('email');

        return (
            <form
                className="form-signin"
                onSubmit={e => form.onSubmit(e, {
                    onSuccess: auth.onLoginSubmit,
                    onError: auth.onErrorSubmit,
                })}>
                <LoginLogo email={emailField.isValid && !emailField.submitting ? emailField.value : null} />

                <Input field={form.$('email')} />
                <Input field={form.$('password')} type="password" />
                <hr />
                <div className="text-center">

                    {auth.isLoggedIn &&
                    !auth.isLoggingIn && // Redirecting to home if logged in !
                    <Redirect to="/home" />}

                    <button
                        className="btn btn-primary mr-2"
                        type="submit"
                        onClick={e => form.onSubmit(e, {
                            onSuccess: auth.onLoginSubmit,
                            onError: auth.onErrorSubmit,
                        })}>
                        <FormattedMessage id="Login.Login" defaultMessage="Login" />
                    </button>
                    <button onClick={this.redirectToAzureAd} type="reset" className="btn btn-dark mr-2" >
                        <svg id="svg-active-directory-ds" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 50 50" style={{ verticalAlign: 'middle', marginRight: '5px' }}> <path fill="#59B4D9" d="M25.001,50.001c-1.232,0-2.392-0.48-3.261-1.352L1.351,28.261C0.492,27.402,0,26.215,0,25 c0-1.214,0.492-2.402,1.351-3.26L21.74,1.352C22.611,0.48,23.769,0,25.001,0c1.231,0,2.39,0.48,3.261,1.352L48.648,21.74 C49.521,22.608,50,23.767,50,25c0,1.233-0.479,2.392-1.353,3.263L28.262,48.649C27.392,49.521,26.232,50.001,25.001,50.001"/> <path fill="#FFFFFF" d="M38.614,21.093c-2.16,0-3.91,1.75-3.91,3.909c0,0.792,0.239,1.527,0.645,2.143l-7.744,7.744 c-0.206-0.144-0.427-0.264-0.656-0.373V14.759c1.167-0.676,1.961-1.924,1.961-3.37C28.91,9.23,27.16,7.48,25,7.48 c-2.158,0-3.908,1.75-3.908,3.909c0,1.446,0.794,2.694,1.96,3.37v19.756c-0.219,0.104-0.434,0.216-0.632,0.353l-7.753-7.753 c0.394-0.61,0.628-1.333,0.628-2.113c0-2.159-1.75-3.909-3.908-3.909c-2.16,0-3.91,1.75-3.91,3.909s1.75,3.909,3.91,3.909 c0.448,0,0.872-0.091,1.274-0.23l8.15,8.15c-0.234,0.548-0.364,1.15-0.364,1.783c0,2.513,2.038,4.551,4.551,4.551 c2.514,0,4.551-2.038,4.551-4.551c0-0.621-0.126-1.212-0.351-1.751l8.173-8.172c0.392,0.132,0.804,0.22,1.241,0.22 c2.158,0,3.908-1.75,3.908-3.909S40.771,21.093,38.614,21.093z"/> <rect x="31.006" y="8.226" transform="matrix(-0.707 0.7072 -0.7072 -0.707 68.2099 8.8718)" opacity="0.5" fill="#FFFFFF" width="2.523" height="20.676"/> <rect x="16.487" y="8.242" transform="matrix(0.7071 0.7071 -0.7071 0.7071 18.3355 -7.1088)" opacity="0.5" fill="#FFFFFF" width="2.524" height="20.677"/> <path fill="#B8D432" d="M27.665,38.614c0,1.496-1.214,2.709-2.71,2.709c-1.497,0-2.709-1.213-2.709-2.709 c0-1.496,1.212-2.709,2.709-2.709C26.45,35.905,27.665,37.118,27.665,38.614"/> <path fill="#B8D432" d="M27.174,11.389c0,1.201-0.973,2.174-2.174,2.174c-1.201,0-2.174-0.973-2.174-2.174 c0-1.201,0.973-2.174,2.174-2.174C26.201,9.215,27.174,10.188,27.174,11.389"/> <path fill="#B8D432" d="M13.563,25.001c0,1.201-0.975,2.174-2.174,2.174c-1.201,0-2.174-0.973-2.174-2.174 c0-1.201,0.973-2.174,2.174-2.174C12.588,22.827,13.563,23.8,13.563,25.001"/> <path fill="#B8D432" d="M40.788,25.001c0,1.201-0.975,2.174-2.175,2.174c-1.2,0-2.174-0.973-2.174-2.174 c0-1.201,0.974-2.174,2.174-2.174C39.813,22.827,40.788,23.8,40.788,25.001"/> <path opacity="0.1" fill="#FFFFFF" d="M28.262,1.352C27.391,0.48,26.233,0,25.001,0c-1.231,0-2.389,0.48-3.26,1.352L1.352,21.74 C0.492,22.598,0,23.786,0,25c0,1.215,0.492,2.403,1.352,3.261l11.543,11.544L34.61,7.699L28.262,1.352z"/> </svg>
                        <FormattedMessage id="Login.LoginAzureAD" defaultMessage="Login with AzureAD" />
                    </button>
                    <p>
                        <small>{form.error}</small>
                    </p>
                    <p>
                        <small>
                            <FormattedMessage
                                id="Login.NotAccountYet"
                                defaultMessage="No account yet?" />
                            <Link to="/signup" className="btn btn-sm btn-secondary ml-2">
                                <FormattedMessage id="Login.SignUp" defaultMessage="SignUp" />
                            </Link>
                        </small>
                    </p>
                </div>
            </form>);
    }
}

FormSignin.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
};

export default injectIntl(FormSignin);
